import { OrderLabel } from '@seen/core/models/orderLabel'
import { type ReactNode, useCallback } from 'react'
import { LabelCombobox } from '#src/components/LabelCombobox.tsx'
import { useCreateMutation } from '#src/hooks/useCreateMutation.ts'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'
import { useSearch } from '#src/hooks/useSearch.ts'

export function OrderLabelCombobox({
  value,
  onChange,
  children,
}: {
  value: OrderLabel['referenceString'][]
  onChange: (value: OrderLabel['referenceString'][]) => any
  children: ReactNode
}): ReactNode {
  const { data: labels } = useSearch(OrderLabel, OrderLabel.baseSearchQuery())
  const createMutation = useCreateMutation<OrderLabel>()
  const createOrderLabel = createMutation.mutate
  const currentPractitioner = useCurrentPractitioner()
  const onCreate = useCallback(
    (name: string, color: string) => {
      createOrderLabel(
        new OrderLabel({
          name,
          color,
          author: currentPractitioner.reference,
        }),
        {
          onSuccess: (l) => {
            onChange([...value, l.referenceString])
          },
        }
      )
    },
    [value, onChange, createOrderLabel, currentPractitioner.reference]
  )
  return (
    <LabelCombobox
      labels={labels}
      value={value}
      onChange={onChange}
      onCreate={onCreate}
      isCreating={createMutation.isPending}
    >
      {children}
    </LabelCombobox>
  )
}
